<template>
  <v-app-bar dense app clipped-left color="white" height="74" style="border-bottom: #e4e4e4 solid 1px; box-shadow: none">
    <v-toolbar-title class="mr-4 align-center pointer">
      <img
        v-if="allowHeaderMenu"
        class="header-logo ml-4"
        src="/plataforma-limer.png"
        alt="Limer"
        role="button"
        tabindex="0"
        @click="goHome"
        @keydown.enter="goHome"
      />
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-menu v-if="allowHeaderMenu" nudge-bottom="5" :close-on-content-click="false" max-width="290" offset-y offset-x>
      <template v-slot:activator="{ on }">
        <v-btn class="text-none mr-4 ml-2" icon color="primary" v-on="on">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>
      <v-card class="header-menu py-5">
        <div class="text-center body-1 px-4 pb-2">
          Olá <span class="font-weight-black">{{ medico.nome }}</span>
        </div>
        <template v-for="item in items">
          <v-list-item
            v-if="showMenuItem(item)"
            class="header-menu__item mx-2"
            color="primary"
            :key="item.to"
            @click="goTo(item.to)"
          >
            <v-list-item-icon>
              <v-icon color="primary">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <div class="mx-5 mt-5">
          <AppButton color="primary" dark block @click="logout">
            <v-icon left>mdi-exit-run</v-icon>Sair
          </AppButton>
        </div>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import authService from '@/services/auth'

interface IMenuItem {
  icon: string
  text: string
  to: string
  requiredRoles?: Array<string>
}
export default Vue.extend({
  name: 'MedicoHeader',
  data: () => ({
    assinaturaDialog: false,
    items: [
      { icon: 'mdi-text-box-check-outline', text: 'Agendamentos', to: 'agendamentos', requiredRoles: ['ocupacional'] },
      { icon: 'mdi-account-circle-outline', text: 'Meu perfil', to: 'perfil' },
      { icon: 'mdi-draw', text: 'Assinatura', to: 'assinatura' },
      { icon: 'mdi-clock-outline', text: 'Agenda médica', to: 'agenda-medica', requiredRoles: ['ocupacional'] },
      {
        icon: 'mdi-text-box-check-outline',
        text: 'Agendamentos',
        to: 'agendamentos-ambulatoriais',
        requiredRoles: ['nutricional', 'psicologico'],
      },
      {
        icon: 'mdi-clock-outline',
        text: 'Agenda médica',
        to: 'agenda-ambulatorial',
        requiredRoles: ['nutricional', 'psicologico'],
      },
    ],
  }),
  computed: {
    ...mapGetters('medico', { medico: 'medico' }),
    allowHeaderMenu() {
      if (this.$route.name === 'login') return

      return true
    },
  },
  methods: {
    showMenuItem(item: IMenuItem) {
      if (item.requiredRoles) {
        return item.requiredRoles.includes(this.medico.tipo_atendimento)
      }
      return true
    },
    ...mapActions('medico', ['resetMedico', 'resetCustomizacao']),
    goTo(route: string) {
      if (this.$route.name !== route) {
        this.$router.push({ name: route })
      }
    },
    goHome() {
      this.goTo(this.medico.tipo_atendimento === 'ocupacional' ? 'agendamentos' : 'agendamentos-ambulatoriais')
    },
    logout() {
      this.$logoutDatadogUser()
      authService.logout()
      this.resetMedico()
      this.$router.push('/login')
    },
  },
})
</script>

<style scoped>
.header-menu {
  border-radius: 14px !important;
}

.header-menu__item {
  border-radius: 10px;
}

.header-logo {
  display: block;
  height: 48px;
  width: auto;
  max-width: 100%;
  cursor: pointer;
}
</style>
